"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function prefixError(block, prefix) {
    try {
        return block();
    }
    catch (error) {
        if (error instanceof Error) {
            error.message = prefix + error.message;
            throw error;
        }
        throw new Error(prefix + JSON.stringify(error));
    }
}
exports.default = prefixError;
//# sourceMappingURL=prefixError.js.map